import { maybeCacheContact } from '@repo/redux/actions/ui';
import Contact from '@repo/utils/models/Contact';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, LinkProps } from 'react-router-dom';

export function buildContactLink(contact) {
  const id = contact.linkID || contact.objectID || contact.id;
  return `/contact/${id}`;
}

export default function ContactLink({
  contact,
  children,
  source,
  onClick,
  ...props
}: Partial<LinkProps> & { contact: Contact; source?: string }) {
  const dispatch = useDispatch();
  const to = {
    pathname: buildContactLink(contact),
    state: { source },
  };

  const handleLinkClick = (e) => {
    dispatch(maybeCacheContact(contact));

    if (onClick) {
      onClick(e);
    }

    e.stopPropagation();
  };

  return (
    <Link to={to} {...props} onClick={handleLinkClick}>
      {children}
    </Link>
  );
}
